import React, { memo, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Popup from '../molecules/Popup';
import { mypage_url, status_code_list } from '../Const';
import { KWANKGM03130A01 } from '../const/api_modules';

interface Props {
  applied: boolean; // 事前審査申込登録状態（前：false、後：true）
  is_staff: boolean;
  reception_cd: string;
  reception_id: number;
  status_code: number;
  has_debtor?: boolean;
  moveNextStep: (step: number) => void;
  movePrevStep: () => void;
  requestModule: (module_name: string) => Promise<any>;
  handleClickTempSave: () => void; // 一時保存
  handleClickChangeDetails?: () => Promise<any>; // 申込内容を変更する
}

// KWANKGM03130 住宅ローンしっかり審査事前審査申込入力（確認）のフッタボタン
const FooterPreExaminationApplicationInputConfirmationAppHousingLoanFirmly: React.FC<Props> = ({
  applied,
  is_staff,
  reception_cd,
  reception_id,
  status_code,
  has_debtor,
  moveNextStep,
  movePrevStep,
  requestModule,
  handleClickTempSave,
  handleClickChangeDetails,
}) => {
  const history = useHistory();
  const [modal_temp_save, setModalTempSave] = useState(false);
  const [modal_change_details, setModalChangeDetails] = useState(false);
  /**
   * ナビゲーションと画面を完了画面に遷移
   */
  const handleClickNext = async () => {
    const module_name = KWANKGM03130A01;
    const result = await requestModule(module_name);

    // 正常終了か判定
    if (result) {
      // 正常終了なら事前審査受付完了画面に遷移
      moveNextStep(4);
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/finish`);
    }
  };

  /**
   * ナビゲーションを前に遷移
   * 画面をKWANKGM03110_住宅ローンしっかり審査事前審査申込入力詳細 へ遷移
   */
  const handleClickPrev = () => {
    movePrevStep();
    history.push(`/reception/${reception_cd}/${reception_id}/${status_code}`);
  };

  /**
   * KWANKGM00180_メール再送画面 へ遷移
   */
  const handleClickResendMail = () => {
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/applicant/mail_resend?r_id=${reception_id}`
    );
  };

  /**
   * 『一時保存する』押下
   */
  const handleClickOpenTempSave = () => {
    handleClickTempSave(); // 一時保存のCommonAPIをキックする
    setModalTempSave(true);
  };

  /**
   * KWANKGM00150_案件一覧（マイページ）へ遷移
   */
  const transitionMypage = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };

  /**
   * 『マイページへ戻る』ボタンを表示
   */
  const jsxMypageButton = () => {
    return (
      <Col xl={6} lg={6} md={6} sm={6} xs={12} className="row-left-button-arrow">
        <div className="text-left">
          <a className="btn btn-xl btn-main-color sp-my-page-return" onClick={transitionMypage}>
            マイページへ
            <br className="d-lg-none d-md-none" />
            戻る
          </a>
        </div>
      </Col>
    );
  };

  /**
   * 『連帯債務者等の方へ確認依頼メールを再送する』ボタンを表示する
   */
  const jsxElementResendMail = () => {
    //連帯債務者等が0人 or 事前審査申込登録前 or 事前審査申込不同意の場合はボタンを非表示。
    if (
      !has_debtor ||
      status_code < status_code_list.preliminary_review_updating ||
      status_code === status_code_list.preliminary_review_disagreed
    ) {
      return null;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-no-arrow">
        <div className="text-right sp-button-center">
          <a className="btn btn-xl btn-main-color" onClick={handleClickResendMail}>
            連帯債務者等の方へ
            <br className="d-lg-none" />
            確認依頼メールを再送する
          </a>
        </div>
      </Col>
    );
  };

  /**
   * 『申込内容を変更する』ボタンを表示する
   */
  const jsxElementChangeDetails = () => {
    //案件ステータスが事前審査保証人不同意の場合のみボタンを表示
    if (status_code !== status_code_list.preliminary_review_disagreed) {
      return null;
    }

    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-no-arrow">
        <div className="text-right sp-button-center">
          <a
            className="btn btn-xl btn-main-color"
            onClick={() => {
              setModalChangeDetails(true);
            }}
          >
            申込内容を変更する
          </a>
        </div>
      </Col>
    );
  };

  /**
   * 事前審査申込登録前の場合ボタンを表示
   */
  const jsxUsualButton = () => {
    // 案件ステータスが事前審査申込登録後 以降はボタンを非表示
    if (status_code >= status_code_list.preliminary_review_updating) {
      return null;
    }
    return (
      <>
        <Row className="my-5">
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-no-arrow">
            <div className="text-left sp-button-center">
              <a className="btn btn-xl btn-main-color" onClick={handleClickOpenTempSave}>
                一時保存する
              </a>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
            <div className="text-right sp-button-center">
              <a
                className="btn btn-xl btn-main-color sp-btn-height ml-auto"
                onClick={handleClickNext}
              >
                次へ進む
              </a>
            </div>
          </Col>
        </Row>

        <Row className="row-left-button">
          <Col className={'text-left p-0'} xl={12} lg={12} md={12} sm={6} xs={6}>
            <div className="text-left sp-button-center">
              <a
                className="btn btn-xl btn-main-color sp-btn-height ml-auto"
                onClick={handleClickPrev}
              >
                戻る
              </a>
            </div>
          </Col>
          <Col xl={6} lg={6} md={6} sm={6} xs={12}></Col>
        </Row>
      </>
    );
  };

  /**
   * 事前審査申込登録後の場合に、下記３つのボタンを表示する
   *
   * 『マイページへ戻る』
   * 『連帯債務者等の方への確認依頼メールを再送する』
   * 『申込内容を変更する』ボタンを表示する
   */
  const outputButton = () => {
    if (status_code >= status_code_list.preliminary_review_updating) {
      return (
        <>
          <Row className="my-5 flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
            {jsxMypageButton()}
            {jsxElementResendMail()}
            {jsxElementChangeDetails()}
          </Row>
        </>
      );
    }
  };

  return (
    <>
      {jsxUsualButton()}
      {outputButton()}
      <Popup
        title="一時保存完了"
        text="入力内容を一時保存しました。このまま入力を続けますか？"
        first_button={{
          label: '入力を続ける',
          variant: 'success',
          handleClick: () => setModalTempSave(false),
        }}
        second_button={{
          label: 'マイページへ戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalTempSave(false);
            location.href = mypage_url;
          },
        }}
        toggleClose={() => setModalTempSave(false)}
        toggleShow={modal_temp_save}
      />
      <Popup
        title="申込内容の変更"
        text="申込内容を変更できる状態に戻します。よろしいですか？"
        first_button={{
          label: '申込内容を変更する',
          variant: 'success',
          handleClick: () => {
            setModalChangeDetails(false);
            // 「申込内容を変更する」の処理（CommonAPIをキックする）
            if (typeof handleClickChangeDetails !== 'undefined') {
              handleClickChangeDetails();
            }
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => setModalChangeDetails(false),
        }}
        toggleClose={() => setModalChangeDetails(false)}
        toggleShow={modal_change_details}
      />
    </>
  );
};

export default memo(FooterPreExaminationApplicationInputConfirmationAppHousingLoanFirmly);
